import { reviewsData } from '../../../mocks/reviews';

export default function ReviewsSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 animate-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Отзывы о реальном выводе бонусных средств
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Реальные истории игроков, которые успешно отыграли бонусы и вывели выигрыши
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {reviewsData.map((review) => (
            <div
              key={review.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 border border-gray-100 hover:scale-105"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-orange-400 to-orange-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{review.name}</div>
                    <div className="text-sm text-gray-500">{review.date}</div>
                  </div>
                </div>
                {review.verified && (
                  <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-checkbox-circle-fill"></i>
                    Проверено
                  </div>
                )}
              </div>

              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`${
                      i < review.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'
                    }`}
                  ></i>
                ))}
              </div>

              <div className="mb-4">
                <div className="inline-block bg-orange-100 text-orange-700 px-3 py-1 rounded-lg font-semibold mb-2">
                  {review.casino}
                </div>
                <div className="text-2xl font-bold text-green-600 mb-2">{review.amount}</div>
              </div>

              <p className="text-gray-700 leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-100">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              Статистика выводов в казино онлайн
            </h3>
            <p className="text-gray-600">Данные за последние 30 дней</p>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">1,247</div>
              <div className="text-gray-700">Успешных выводов</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">89%</div>
              <div className="text-gray-700">Отыграли бонус</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">2.5ч</div>
              <div className="text-gray-700">Средний вывод</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">127М ₽</div>
              <div className="text-gray-700">Общая сумма</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}